import React from 'react';

//component for the "Loading..." message while waiting for photo request to complete
function Loading() {
    return (<li className="not-found">
    <h3>Loading...</h3>
  </li>);
  }

  export default Loading;